module.exports = __webpack_public_path__ + "img/google_icon.5d2648f5.svg";